import { getContext } from 'svelte';
import type { WishlistContext } from '../createWishlistContext/createWishlistContext';
import { Contexts } from '#lib/constants/contexts.js';

// Returns `undefined` when the Wishlist feature flag is off, since the context
// is only set in that case. Consumers must tolerate an absent context.
export const getWishlistContext = () => {
	return getContext<WishlistContext | undefined>(Contexts.Wishlist);
};
